export enum DeviceTypes {
  MOBILE,
  TABLET,
  DESKTOP,
}
